import { render, staticRenderFns } from "./MachineTranslationsTable.vue?vue&type=template&id=8943484a&"
import script from "./MachineTranslationsTable.vue?vue&type=script&lang=ts&"
export * from "./MachineTranslationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8943484a')) {
      api.createRecord('8943484a', component.options)
    } else {
      api.reload('8943484a', component.options)
    }
    module.hot.accept("./MachineTranslationsTable.vue?vue&type=template&id=8943484a&", function () {
      api.rerender('8943484a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/machinetranslations/MachineTranslationsTable.vue"
export default component.exports